import React from "react";
import mandate from "../../../../assets/images/mandate.png";
export default function Sanction(props) {
  const { mandateDetails, setIsExpanded, isExpanded, applicationDetails } =
    props;
  return (
    <div
      style={{
        border: "solid",
        borderRadius: "10px",
        borderWidth: "1px",
        borderColor: "#DBDBDB",
        height: "auto",
        padding: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          height: "30px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <img
            style={{ height: "28px", width: "33px" }}
            src={mandate}
            alt="mandate"
          />
          <p
            style={{
              fontFamily: "Inter-Medium",
              marginLeft: "10px",
              fontSize: "14px",
              marginTop: "13px",
            }}
          >
            E-Mandate :{" "}
          </p>
        </div>
      </div>
      <div
        style={{
          borderTop: "0.75px solid #DBDBDB",
          margin: "10px 0",
        }}
      ></div>

      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <div
          style={{
            width: "200px",
            height: "60px",
            marginBottom: "10px",
          }}
        >
          <p style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                color: "gray",
                fontFamily: "Inter-Medium",
                fontWeight: "300",
                lineHeight: "20px",
                fontSize: "15px",
              }}
            >
              Name
            </span>

            <span
              onClick={() => setIsExpanded(!isExpanded)}
              title={
                applicationDetails?.coapplicantProfile?.userDetails?.name || ""
              }
              style={{
                whiteSpace: isExpanded ? "normal" : "nowrap",
                textOverflow: isExpanded ? "unset" : "ellipsis",
                overflow: isExpanded ? "unset" : "hidden",
                cursor: isExpanded ? "auto" : "pointer",
                textDecoration: "none",
                color: "#232323",
                fontSize: "13px",
                fontFamily: "Inter-Medium",
                lineHeight: isExpanded ? "15px" : "30px",
                display: "block",
                width: "100%",
                wordBreak: "break-word",
              }}
            >
              {mandateDetails?.name || "-------"}
            </span>
          </p>
        </div>
        <div
          style={{
            width: "200px",
            height: "60px",
            marginBottom: "10px",
          }}
        >
          <p style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                color: "gray",
                fontFamily: "Inter-Medium",
                fontWeight: "300",
                lineHeight: "20px",
                fontSize: "15px",
              }}
            >
              Account Number
            </span>

            <span
              style={{
                color: "#232323",
                fontSize: "13px",
                fontFamily: "Inter-Medium",
                lineHeight: "30px",
              }}
            >
              {mandateDetails?.accountNumber || "-------"}
            </span>
          </p>
        </div>
        <div
          style={{
            width: "200px",
            height: "60px",
            marginBottom: "10px",
          }}
        >
          <p style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                color: "gray",
                fontFamily: "Inter-Medium",
                fontWeight: "300",
                lineHeight: "20px",
                fontSize: "15px",
              }}
            >
              Account Type
            </span>

            <span
              style={{
                color: "#232323",
                fontSize: "13px",
                fontFamily: "Inter-Medium",
                lineHeight: "30px",
              }}
            >
              {mandateDetails?.accountType || "-------"}
            </span>
          </p>
        </div>
        <div
          style={{
            width: "200px",
            height: "60px",
            marginBottom: "10px",
          }}
        >
          <p style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                color: "gray",
                fontFamily: "Inter-Medium",
                fontWeight: "300",
                lineHeight: "20px",
                fontSize: "15px",
              }}
            >
              IFSC Code{" "}
            </span>

            <span
              style={{
                color: "#232323",
                fontSize: "13px",
                fontFamily: "Inter-Medium",
                lineHeight: "30px",
              }}
            >
              {mandateDetails?.ifsc || "-------"}
            </span>
          </p>
        </div>
        <div
          style={{
            width: "200px",
            height: "60px",
            marginBottom: "10px",
          }}
        >
          <p style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                color: "gray",
                fontFamily: "Inter-Medium",
                fontWeight: "300",
                lineHeight: "20px",
                fontSize: "15px",
              }}
            >
              Customer mobile
            </span>

            <span
              style={{
                color: "#232323",
                fontSize: "13px",
                fontFamily: "Inter-Medium",
                lineHeight: "30px",
              }}
            >
              {mandateDetails?.phone || "-------"}
            </span>
          </p>
        </div>
        <div
          style={{
            width: "200px",
            height: "60px",
            marginBottom: "10px",
          }}
        >
          <p style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                color: "gray",
                fontFamily: "Inter-Medium",
                fontWeight: "300",
                lineHeight: "20px",
                fontSize: "15px",
              }}
            >
              Mandate Type{" "}
            </span>

            <span
              style={{
                color: "#232323",
                fontSize: "13px",
                fontFamily: "Inter-Medium",
                lineHeight: "30px",
              }}
            >
              {mandateDetails?.mandateType || "-------"}
            </span>
          </p>
        </div>
        <div
          style={{
            width: "200px",
            height: "60px",
            marginBottom: "10px",
          }}
        >
          <p style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                color: "gray",
                fontFamily: "Inter-Medium",
                fontWeight: "300",
                lineHeight: "20px",
                fontSize: "15px",
              }}
            >
              CustomerId
            </span>

            <span
              style={{
                color: "#232323",
                fontSize: "13px",
                fontFamily: "Inter-Medium",
                lineHeight: "30px",
              }}
            >
              {mandateDetails?.customerId || "-------"}
            </span>
          </p>
        </div>
        <div
          style={{
            width: "200px",
            height: "60px",
            marginBottom: "10px",
          }}
        >
          <p style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                color: "gray",
                fontFamily: "Inter-Medium",
                fontWeight: "300",
                lineHeight: "20px",
                fontSize: "15px",
              }}
            >
              TokenId
            </span>

            <span
              style={{
                color: "#232323",
                fontSize: "13px",
                fontFamily: "Inter-Medium",
                lineHeight: "30px",
              }}
            >
              {mandateDetails?.tokenId || "-------"}
            </span>
          </p>
        </div>
        <div
          style={{
            width: "200px",
            height: "60px",
            marginBottom: "10px",
          }}
        >
          <p style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                color: "gray",
                fontFamily: "Inter-Medium",
                fontWeight: "300",
                lineHeight: "20px",
                fontSize: "15px",
              }}
            >
              PaymentId
            </span>

            <span
              style={{
                color: "#232323",
                fontSize: "13px",
                fontFamily: "Inter-Medium",
                lineHeight: "30px",
              }}
            >
              {mandateDetails?.paymentId || "-------"}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}
